// extracted by mini-css-extract-plugin
module.exports = {"purchase__menu":"PurchaseMenu_purchase__menu__lI1Tq","menu__item":"PurchaseMenu_menu__item__XeaJh","active":"PurchaseMenu_active__7aZpQ"};